"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var actionTypes_1 = __importDefault(require("./actionTypes"));
var initialState = {
    domainId: '',
    domainName: '',
    agentsList: [],
    currentAgentId: '',
    currentAgentData: {},
    actionsList: [],
    currentActionData: {},
    envVariables: [],
    errors: {},
    availableModels: [],
};
function reduce(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes_1["default"].SET_DOMAIN_ID:
            return __assign(__assign({}, state), { domainId: action.data });
        case actionTypes_1["default"].SET_DOMAIN_NAME:
            return __assign(__assign({}, state), { domainName: action.data });
        case actionTypes_1["default"].SET_AGENTS_LIST:
            return __assign(__assign({}, state), { agentsList: action.data });
        case actionTypes_1["default"].SET_CURRENT_AGENT_ID:
            return __assign(__assign({}, state), { currentAgentId: action.data });
        case actionTypes_1["default"].SET_CURRENT_AGENT_DATA:
            return __assign(__assign({}, state), { currentAgentData: action.data });
        case actionTypes_1["default"].SET_ACTIONS:
            return __assign(__assign({}, state), { actionsList: action.data });
        case actionTypes_1["default"].SET_CURRENT_ACTION_DATA:
            return __assign(__assign({}, state), { currentActionData: action.data });
        case actionTypes_1["default"].SET_ENV_VARIABLES:
            return __assign(__assign({}, state), { envVariables: action.data });
        case actionTypes_1["default"].SET_ERRORS:
            return __assign(__assign({}, state), { errors: action.data });
        case actionTypes_1["default"].SET_AVAILABLE_MODELS:
            return __assign(__assign({}, state), { availableModels: action.data });
        default:
            return state;
    }
}
exports["default"] = reduce;
